import React from 'react';

import styles from './BadgeFilter.module.scss';
import close from '../../constants/images/close-dark.svg';

const BadgeFilter = ({onClick, title}) => {
    return (
        <div className={styles.badge}>
            <p> {title}</p>
            <img onClick={onClick} src={close} alt="close"/>
        </div>
    );
};

export default BadgeFilter;
